import { render, staticRenderFns } from "./ManageLabel.vue?vue&type=template&id=49a5b019&scoped=true"
import script from "./ManageLabel.vue?vue&type=script&lang=js"
export * from "./ManageLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5b019",
  null
  
)

export default component.exports